/**
 * Custom hook for Google Analytics page tracking
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import googleAnalytics from '../services/googleAnalytics';

export const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views on route changes
    const pageTitle = getPageTitle(location.pathname);
    const pageLocation = window.location.href;
    
    googleAnalytics.trackPageView(pageTitle, pageLocation);
  }, [location]);
};

function getPageTitle(pathname) {
  const pageTitles = {
    '/': 'Home - Kids Investment Game',
    '/signup': 'Sign Up - Kids Investment Game',
    '/login': 'Login - Kids Investment Game',
    '/dashboard': 'Dashboard - Kids Investment Game',
    '/stocks': 'Stocks - Kids Investment Game',
    '/groups': 'Groups - Kids Investment Game',
    '/groups/rankings': 'Group Rankings - Kids Investment Game',
    '/mobile/financial': 'Mobile Financial - Kids Investment Game'
  };

  return pageTitles[pathname] || `${pathname} - Kids Investment Game`;
}

export default useGoogleAnalytics;